// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1hlSP","validationTips":"StatementDescriptor_validationTips__1zRXh"};